// PaymentFailure.js
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const PaymentFailure = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const getQueryParams = () => {
    const searchParams = new URLSearchParams(location.search);
    return {
      mihpayid: searchParams.get("mihpayid"),
      mode: searchParams.get("mode"),
      status: searchParams.get("status"),
      txnid: searchParams.get("txnid"),
      amount: searchParams.get("amount"),
      net_amount_debit: searchParams.get("net_amount_debit"),
      bank_ref_num: searchParams.get("bank_ref_num"),
      field1: searchParams.get("field1"),
      field2: searchParams.get("field2"),
      field3: searchParams.get("field3"),
      field7: searchParams.get("field7"),
      field8: searchParams.get("field8"),
      field9: searchParams.get("field9"),
    };
  };

  const paymentDetails = getQueryParams();

  const handleReturnHome = () => {
    navigate("/"); // Adjust this route to your home page
  };

  return (
    <div className="vv-payment-failure-container">
      <div className="vv-failure-card">
        <div className="vv-failure-icon">✗</div>
        <h1 className="vv-failure-heading">Payment Failed</h1>
        <p className="vv-failure-text">We're sorry, but there was an issue processing your payment.</p>

        <div className="vv-payment-failure-details">
          <h3>Transaction Details</h3>
          <div className="vv-failure-detail-item">
            <span>Transaction ID:</span>
            <span>{paymentDetails.txnid || "N/A"}</span>
          </div>
          <div className="vv-failure-detail-item">
            <span>Amount:</span>
            <span>₹{paymentDetails.amount ? parseFloat(paymentDetails.amount).toFixed(2) : "N/A"}</span>
          </div>
          <div className="vv-failure-detail-item">
            <span>Payment Mode:</span>
            <span>{paymentDetails.mode || "N/A"}</span>
          </div>
          <div className="vv-failure-detail-item">
            <span>Status:</span>
            <span>{paymentDetails.field9 || paymentDetails.status || "Unknown Error"}</span>
          </div>
          <div className="vv-failure-detail-item">
            <span>Date:</span>
            <span>{new Date().toLocaleDateString()}</span>
          </div>
        </div>

        <p className="vv-failure-help-text">Please try again or contact support if the issue persists.</p>
        <p className="vv-failure-help-text">Contact support at 1800 103 4916 or support@indusviva.com.</p>

        <div className="vv-failure-button-group">
          <button className="vv-failure-return-home-button" onClick={handleReturnHome}>
            Return to Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailure;
